module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.5c8f913c.jpg";